/**
 * @file Single auth entry page (`/authorize`).
 * @module @labcraft/lab/ui/pages/authorize
 *
 * One page, one URL — sign-up and sign-in collapse here. The
 * backend resolves new vs returning via `findOrLinkByClaims`; the
 * gateway's `resolvePostAuthRedirect` decides where to drop the
 * user based on `status` + `profileCompletedAt`.
 *
 * Legacy `/signin` URLs redirect here at the router layer.
 *
 * The form itself lives in the shared `<AuthCard>` component
 * ([../../components/auth_card.tsx](../../components/auth_card.tsx))
 * — its sibling `<AuthCTA>` is embedded into the landing page's
 * marketing CTA section and the manifesto's close, so the entry
 * surface is the same call across the whole public site (only the
 * visual treatment differs).
 */

import { type JSX } from 'react'
import { useSearchParams } from 'react-router'
import { AuthCard } from '@labcraft/lab/ui/components/auth_card.tsx'
import styles from './auth.module.css'

export function SigninPage(): JSX.Element {
  const [searchParams] = useSearchParams()
  const expired = searchParams.get('expired') === '1'
  const next = searchParams.get('next')

  return (
    <main className={styles.main}>
      <AuthCard
        {...(next !== null && { next })}
        {...(expired && { expired: true })}
      />
    </main>
  )
}
